export const ADMIN = 'ADMIN'
export const MANAGER = 'MANAGER'
export const AGENT = 'AGENT'
